exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".posts-list.has-big-in-top .post-item[data-v-de6cee6e]:first-child{height:355px}.posts-list.has-big-in-top .post-item:first-child img[data-v-de6cee6e]{object-fit:cover;width:100%;height:220px}.posts-list.has-big-in-top .post-item[data-v-de6cee6e]:nth-last-child(-n+3){height:70px}.ad-728-90-category-below[data-v-de6cee6e]{text-align:center;margin-top:20px;height:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de6cee6e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CategoryBox.vue
// module id = 134
// module chunks = 0